export const onSubscribeSticky = (plan_id: string, coupon?: string) => {
  let route = `/checkout?plan_id=${plan_id}`;
  if (coupon) {
    route += `&coupon=${coupon}`;
  }
  return route;
};
